import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

/**
 * Fetches the current shipping price from the server
 * @returns {Promise<Object>} The shipping price data
 */
export const getShippingPrice = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/shipping`);
    
    if (response.data.status === 200) {
      return response.data.data;
    }
    
    throw new Error('Failed to fetch shipping price');
  } catch (error) {
    console.error('Error fetching shipping price:', error);
    // Return a default shipping price if the API call fails
    return {
      price: 35,
      active: true
    };
  }
};

/**
 * Updates the shipping price (admin only)
 * @param {number} price - The new shipping price
 * @returns {Promise<Object>} The updated shipping price data
 */
export const updateShippingPrice = async (price) => {
  try {
    const response = await axios.put(`${BASE_URL}/shipping`, { price });
    
    if (response.data.status === 200) {
      return response.data.data;
    }
    
    throw new Error('Failed to update shipping price');
  } catch (error) {
    console.error('Error updating shipping price:', error);
    throw error;
  }
};
